// extracted by mini-css-extract-plugin
export default {"box":"viewer-mode-panel_box__TfIrg"};